import { NgModule } from '@angular/core';
import { DfFormlyModule } from '@degreed/fresco';
import { FlexEdModule } from '@app/flex-ed/flex-ed.module';
import { GroupsSharedModule } from '@app/groups/groups-shared.module';
import { InputsModule } from '@app/inputs/inputs.module';
import { MentoringModule } from '@app/mentoring/mentoring.module';
import { NavigationModule } from '@app/navigation/navigation.module';
import { CertificationDetails } from '@app/profile/components/certification-details/certification-details.component';
import { ParsedResumeIndicator } from '@app/profile/components/profile-overview/build-your-profile/parsed-resume-indicator/parsed-resume-indicator.component';
import { ProfileOverviewLoading } from '@app/profile/components/profile-overview/loading-state/profile-loading.component';
import { StackedSkillRatingsComponent } from '@app/profile/components/profile-overview/overview-skills-table/stacked-skill-ratings/stacked-skill-ratings.component';
import { RecommendationsModule } from '@app/recommendations/recommendations.module';
import { SearchFiltersModule } from '@app/search/components/search-filters/search-filters.module';
import { SharedModule } from '@app/shared/shared.module';
import { TagsModule } from '@app/tags/tags.module';
import { UserModule } from '@app/user/user.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileNotFoundComponent } from './components/profile-not-found/profile-not-found.component';
import { BuildYourProfileComponent } from './components/profile-overview/build-your-profile/build-your-profile.component';
import { OverviewSkillsTableComponent } from './components/profile-overview/overview-skills-table/overview-skills-table.component';
import { ProfileOverviewComponent } from './components/profile-overview/profile-overview.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ProfileActivity } from './components/profile-overview/profile-activity/profile-activity.component';
import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileSharedModule } from './profile-shared.module';
import { ResourceLauncherModule } from '@app/resource-launcher/resource-launcher.module';

import { UserInfoBioModal } from '@app/profile/components/profile-header/user-info/user-info-bio-modal.component';
import { ProfileGlobalStylesComponent } from '@app/profile/components/profile/profile-global-styles.component';
import { ProfileSocialModal } from '@app/profile/components/profile-header/profile-social-modal/profile-social-modal.component';
import { FollowersTabComponent } from '@app/profile/components/profile-header/profile-social-modal/followers-tab/followers-tab.component';
import { FollowingTabComponent } from '@app/profile/components/profile-header/profile-social-modal/following-tab/following-tab.component';
import { GroupsTabComponent } from '@app/profile/components/profile-header/profile-social-modal/groups-tab/groups-tab.component';
import { FollowProfileButton } from '@app/profile/components/profile-header/follow-profile-button/follow-profile-button.component';
import { UserInfo } from '@app/profile/components/profile-header/user-info/user-info.component';
import { ShareProfileButton } from '@app/profile/components/profile-header/share-profile-button/share-profile-button.component';
import { FollowingCountButton } from '@app/profile/components/profile-header/following-count-button/following-count-button.component';
import { FollowUserButton } from './components/follow-user-button/follow-user-button.component';

import { ProfileOverviewAchievementsComponentV2 } from './components/profile-overview-v2/achievements/achievements.component';
import { BuildYourProfileComponentV2 } from './components/profile-overview-v2/build-your-profile/build-your-profile.component';
import { AddMenuV2 } from './components/profile-overview-v2/components/add-menu/add-menu.component';
import { ProfileCardCarouselComponentV2 } from './components/profile-overview-v2/components/card-carousel/profile-card-carousel.component';
import { ProfileHeadingComponentV2 } from './components/profile-overview-v2/components/header/profile-heading.component';
import { ProfileSectionEmptyStateComponentV2 } from './components/profile-overview-v2/components/section-empty-state/profile-section-empty-state.component';
import { ProfileExperienceComponentV2 } from './components/profile-overview-v2/experiences/profile-experience.component';
import { ProfileLearningComponentV2 } from './components/profile-overview-v2/learning/profile-learning.component';
import { OverviewSkillsTableComponentV2 } from './components/profile-overview-v2/overview-skills-table/overview-skills-table.component';
import { ProfileOverviewComponent as ProfileOverviewComponentV2 } from './components/profile-overview-v2/profile-overview.component';
import { ParsedResumeIndicatorV2 } from '@app/profile/components/profile-overview-v2/build-your-profile/parsed-resume-indicator/parsed-resume-indicator.component';
import { ProfileOverviewLoadingV2 } from '@app/profile/components/profile-overview-v2/loading-state/profile-loading.component';
import { StackedSkillRatingsComponentV2 } from '@app/profile/components/profile-overview-v2/overview-skills-table/stacked-skill-ratings/stacked-skill-ratings.component';
import { SignalCountChartComponentV2 } from '@app/profile/components/profile-overview-v2/signal-count-chart/signal-count-chart.component';
import { SignalHistoryChartComponentV2 } from '@app/profile/components/profile-overview-v2/signal-history-chart/signal-history-chart.component';
import { ProfileActivityV2 } from './components/profile-overview-v2/profile-activity/profile-activity.component';

/**
 * NOTE: This module is lazyloaded, do not import it directly into another component
 *
 * If you need to use components/services that are specific to this module, move
 * them out into the `profile-shared.module` and import that that module into your
 * module instead.
 *
 */

@NgModule({
  declarations: [
    BuildYourProfileComponent,
    ParsedResumeIndicator,
    OverviewSkillsTableComponent,
    ProfileComponent,
    ProfileOverviewLoading,
    ProfileOverviewComponent,
    StackedSkillRatingsComponent,
    ProfileNotFoundComponent,
    CertificationDetails,
    ProfileActivity,
    UserInfoBioModal,
    ProfileGlobalStylesComponent,
    ProfileSocialModal,
    FollowersTabComponent,
    FollowingTabComponent,
    GroupsTabComponent,
    FollowProfileButton,
    UserInfo,
    ShareProfileButton,
    FollowingCountButton,
    FollowUserButton,

    ProfileOverviewAchievementsComponentV2,
    BuildYourProfileComponentV2,
    AddMenuV2,
    ProfileCardCarouselComponentV2,
    ProfileHeadingComponentV2,
    ProfileSectionEmptyStateComponentV2,
    ProfileExperienceComponentV2,
    ProfileLearningComponentV2,
    OverviewSkillsTableComponentV2,
    ProfileOverviewComponentV2,
    ParsedResumeIndicatorV2,
    ProfileOverviewLoadingV2,
    StackedSkillRatingsComponentV2,
    SignalCountChartComponentV2,
    SignalHistoryChartComponentV2,
    ProfileActivityV2,
  ],
  imports: [
    ProfileSharedModule,
    FlexEdModule,
    GroupsSharedModule,
    InputsModule,
    NavigationModule,
    NgbDropdownModule,
    ProfileRoutingModule,
    RecommendationsModule,
    SharedModule,
    TagsModule,
    SearchFiltersModule,
    MentoringModule,
    UserModule,
    ResourceLauncherModule,
    DfFormlyModule,
  ],
  exports: [],
  providers: [],
})
export class ProfileModule {}
